// Libs
import classNames from 'classnames/bind';
import { Box, InputAdornment, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ChangeEvent, useEffect, useState } from 'react';
// Components, Layouts, Pages
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
// Styles, images, icons
import styles from './ConversationInputSearch.module.scss';
import { icons } from '~/assets';

type Props = {
  value?: string;
  width?: number | string;
  onChange?: (searchValue: string) => void;
};

const cx = classNames.bind(styles);

const ConversationInputSearch = (props: Props) => {
  //#region Destructuring Props
  const { value, width, onChange } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [searchValue, setSearchValue] = useState<string>(EMPTY_STRING);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    setSearchValue(value || EMPTY_STRING);
  }, [value]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleSearchChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setSearchValue(value);
    onChange && onChange(value.trim());
  };
  //#endregion Handle Function

  return (
    <Box
      component={'div'}
      id='conversationInputSearchComponent'
      style={{ width }}
      className={cx('searchContainer')}
    >
      <TextField
        placeholder={t('common_conversation_search_placeholder')}
        sx={{ width }}
        value={searchValue}
        onChange={handleSearchChange}
        onClick={(e) => e.stopPropagation()}
        slotProps={{
          input: {
            inputProps: {
              className: cx('inputProps'),
            },
            className: cx('searchInput'),
            style: { width },
            startAdornment: (
              <InputAdornment position='start' className={cx('inputAdornment')}>
                <img
                  src={icons.conversationIconSearch}
                  alt={cx(t('common/base'))}
                  className={cx('searchIcon')}
                />
              </InputAdornment>
            ),
          },
        }}
      />
    </Box>
  );
};

export default ConversationInputSearch;
